// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__vEXO9","notes":"Notes_notes__2jF7t"};